/**
 * Formats a valid @param dateString to be presented on the UI. When dateString
 * cannot be parsed, returns '-'.
 * @param dateString A string value representing a date and time stamp.
 * @returns A well-formatted date ('dd.MM.yyyy HH:mm:ss) or '-'
 */
export const dateTimeFormatter = (dateString: string, lang: string): string => {
    const date = Date.parse(dateString);
    if (!date) {
        return '-';
    }

    return dateTimeFormat(lang).format(date);
};

/** global formatter const for performance reasons */
const dateTimeFormat = (lang: string) =>
    Intl.DateTimeFormat(lang, {
        timeStyle: 'medium',
        dateStyle: 'short',
    });

/**
 * Formats a valid @param dateString to be presented on the UI. When dateString
 * cannot be parsed, returns '-'.
 * @param dateString A string value representing a date and time stamp.
 * @returns A well-formatted date ('dd.MM.yyyy) or '-'
 */
export const dayTimeFormatter = (dateString: string, lang: string): string => {
    const date = Date.parse(dateString);
    if (!date) {
        return '-';
    }

    return dayTimeFormat(lang).format(date);
};

const dayTimeFormat = (lang: string) =>
    Intl.DateTimeFormat(lang, { year: 'numeric', month: '2-digit', day: '2-digit' });
